import Vue from 'vue'
import { Message } from 'element-ui'
import axios from 'axios'
// import _ from 'lodash'
// import { router } from './vue-router';
// import store from '@/store'
// import qs from 'querystringify'
// 设置固定访问url
const base_url = 'http://60.221.214.214:8025/hadapi_dp'
// create an axios instance
const service = axios.create({
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 600000 // request timeout
})
// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        // const { method, data, contentType } = config
        // // parse data
        // if (contentType === 'json') {
        //   config.headers['Content-Type'] = 'application/json'
        // } else if (method !== 'get' && _.isObject(data)) {
        //   if (typeof config.headers['Content-Type'] === 'undefined') {
        //     // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        //     config.data = qs.stringify(data)
        //   }
        // }
        if (localStorage.getItem('third-token')) {
            config.headers['third-token'] = localStorage.getItem('third-token')
        }

        if (localStorage.getItem('auth_token') || localStorage.getItem('auth_token') === '') {
            config.headers['authorization'] = localStorage.getItem('auth_token')

        } else {
            // router.push('/login')
        }
        // 设置固定访问url
        config.baseURL = base_url
        // console.log(config, 'config')
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        // console.log(response,'response')
        const res = response.data
        // if the custom code is not 20000, it is judged as an error.
        console.log(response)
        if (response.config.url == '/auth/third') {
            return res
        }
        if (res.code !== 200) {
            // if (res.code === 10001) {
            //   // to re-login
            //   setTimeout(() => {
            //     router.push('/login')
            //   }, 200)
            // } else {
            //   Message.error(res.message)
            // }
            Message.error(res.message)
            // return Promise.reject(new Error(res.message || 'Error'))
        } else if (res.code == 401) {
            localStorage.setItem('third-token', '')
            this.router.push('/')
        } else {
            return res
        }
    },
    error => {
        return Promise.reject(error)
    }
)
Vue.$request = service
export default service